<template>
  <div class="baniere md:pt-16 md:pb-20">
    <div class="w-full pt-4">
      <div class="titre w-full mt-5 text-center">
        Nous avons accompli de belles oeuvres avec eux :
      </div>
    </div>

    <div class="web">
      <div class="flex mt-20 w-full h-auto justify-center">
        <img
          src="../../../assets/images/jpg/aab_logo.jpg"
          alt="image logo aab"
          class="mr-24"
        >
        <img
          src="../../../assets/images/jpg/oremi_logo.jpg"
          alt="image logo oremi"
          class="mr-24"
        >
        <img
          src="../../../assets/images/jpg/finlo_logo.jpg"
          alt="image logo finlo"
          class="mr-24"
        >
        <img
          src="../../../assets/images/jpg/btf_logo.jpg"
          alt="image logo bft"
          class="mr-24"
        >
        <img
          src="../../../assets/images/jpg/acrc_logo.jpg"
          alt="image logo acrc"
        >
      </div>

      <div class="flex mt-20 w-full h-auto justify-center">
        <img
          src="../../../assets/images/jpg/ylomi_logo.jpg"
          alt="image logo ylomi"
          class="mr-12"
        >
        <img
          src="../../../assets/images/jpg/rema_logo.jpg"
          alt="image logo rema"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/asass_logo.jpg"
          alt="image logo asass"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/arsen_logo.jpg"
          alt="image logo arsen"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/kasua_logo.jpg"
          alt="image logo kasua"
        >
      </div>

      <div class="flex mt-20 w-full h-auto justify-center">
        <img
          src="../../../assets/images/jpg/orion_logo.jpg"
          alt="image logo orion"
          class="mr-12"
        >
        <img
          src="../../../assets/images/jpg/passvip_logo.jpg"
          alt="image logo passvip"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/Qelios_logo.jpg"
          alt="image logo qelios"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/BGFI_logo.jpg"
          alt="image logo bgfi"
          class="mr-16"
        >
        <img
          src="../../../assets/images/jpg/afg_logo.jpg"
          alt="image logo afg"
        >
      </div>
    </div>

    <hooper
      :settings="hooperSettings"
      :transition="400"
      class="hopper mt-16 apparence-none"
    >
      <slide
        class="slide"
      >
        <div class="pl-6 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/aab_logo_min.jpg"
              alt=""
              class="aab mr-10"
            >
            <img
              src="../../../assets/images/jpg/oremi_logo.jpg"
              alt=""
              class="mr-6 oremi"
            >
          </div>
        </div>

        <div class="pl-6 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/ylomi_logo.jpg"
              alt=""
              class="ylomi mr-3"
            >
            <img
              src="../../../assets/images/jpg/rema_logo.jpg"
              alt=""
              class="mr-6 aab"
            >
          </div>
        </div>

        <div class="pl-6 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/orion_logo.jpg"
              alt=""
              class="ylomi mr-16"
            >
            <img
              src="../../../assets/images/jpg/passvip_logo.jpg"
              alt=""
              class="mr-6 oremi"
            >
          </div>
        </div>
      </slide>

      <slide
        class="slide"
      >
        <div class="pl-16 pr-6 mb-12">
          <div class="flex items-center">
            <img
              src="../../../assets/images/jpg/finlo_logo.jpg"
              alt=""
              class="aab mr-10"
            >
            <img
              src="../../../assets/images/jpg/btf_logo.jpg"
              alt=""
              class=" ylomi"
            >
          </div>
        </div>

        <div class="pl-20 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/asass_logo.jpg"
              alt=""
              class="ylomi mr-6"
            >
            <img
              src="../../../assets/images/jpg/arsen_logo.jpg"
              alt=""
              class=" ylomi"
            >
          </div>
        </div>

        <div class="pl-16 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/Qelios_logo.jpg"
              alt=""
              class="ylomi mr-16"
            >
            <img
              src="../../../assets/images/jpg/BGFI_logo.jpg"
              alt=""
              class="ylomi"
            >
          </div>
        </div>
      </slide>

      <slide
        class="slide"
      >
        <div class="pl-6 pr-6 mb-12">
          <div class="flex items-center">
            <img
              src="../../../assets/images/jpg/acrc_logo.jpg"
              alt=""
              class="aab mr-10"
            >
          </div>
        </div>

        <div class="pl-32 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/kasua_logo.jpg"
              alt=""
              class="aab mr-6"
            >
          </div>
        </div>

        <div class="pl-32 pr-6 mb-12">
          <div class="flex ">
            <img
              src="../../../assets/images/jpg/afg_logo.jpg"
              alt=""
              class="ylomi mr-16"
            >
          </div>
        </div>
      </slide>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'Index',
  components: {
    Hooper,
    Slide
  },
  props: {
  },
  data () {
    return {
      hooperSettings: {
        infiniteScroll: false,
        centerMode: false,
        breakpoints: {
          2400: {
            itemsToShow: 10
          },
          1800: {
            itemsToShow: 9
          },
          1500: {
            itemsToShow: 8
          },
          1100: {
            itemsToShow: 3
          },
          543: {
            itemsToShow: 2.3
          },
          0: {
            itemsToShow: 1.4
          }
        }
      }
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .titre{
    font-weight: bold;
    font-size: 36px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $black;
  }
img{
  height: 72px;
}
.hopper{
  display: none;
}

  @media screen and (max-width: 600px){
    .web{
      display: none;
    }
    .hopper{
      display: block;
      height: auto;
    }
    .baniere{
      padding-left: 0px;
      padding-right: 0px;
    }
    .titre{
      font-size: 26px;
      line-height: 170%;
    }
    .aab{
      Width: 159.9px;
      height: 50.98px
    }
    .oremi{
      width: 51.63px;
      height: 51.63px;
    }
    .ylomi{
      width: 140.54px;
      height: 45.17px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .mr-24, .mr-16{
      margin-right: 30px;
    }
    img{
      height: 50px;
    }
  }
</style>
